/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registrations_TitleInputs */

const en_admin_registrations_title = /** @type {(inputs: Admin_Registrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The following companies would like to participate in the Matching Week:`)
};

const de_admin_registrations_title = /** @type {(inputs: Admin_Registrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgende Unternehmen möchten an der Matching Week teilnehmen:`)
};

/**
* | output |
* | --- |
* | "The following companies would like to participate in the Matching Week:" |
*
* @param {Admin_Registrations_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registrations_title = /** @type {((inputs?: Admin_Registrations_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registrations_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registrations_title(inputs)
	return en_admin_registrations_title(inputs)
});